import styled from "@emotion/styled";
import { colors } from "src/theme";
import { Flex } from "../grid";
import { Text } from "../typography";
import { MergeWithOverwrite } from "src/common";

const Step = styled.div((props: { isActive: boolean }) => ({
  backgroundColor: props.isActive ? colors.success : colors.primary,
  height: '4px',
  borderRadius: '4px',
  width: '100%',
}))

export type StepperProps = MergeWithOverwrite<React.HTMLAttributes<HTMLDivElement>, {
  currentStep: number;
  totalSteps: number;
  showLabel?: boolean;
}>;

export const Stepper = ({ currentStep, totalSteps, showLabel = true }: StepperProps) => {

  return (
    <Flex vertical gap={4}>
      {showLabel && <Text as="p" type="base" color={colors.successText}>Korak {currentStep} od {totalSteps}</Text>}
      <div aria-hidden="true">
        <Flex gap={4}>
          {[...Array(totalSteps)].map((_, index) => (
            <Step key={index} isActive={index + 1 <= currentStep} />
          ))}
        </Flex>
      </div>
    </Flex>
  );
}
